module.exports = __webpack_public_path__ + "static/Slectrooms-ee52f7d22113dcc60422a7da6bfe0a67.png";